import React from 'react';
import { useParams } from 'react-router-dom';

import { OfferUpdatePageContainer as CampaignComponentUpdatePageContainer } from '@occc-app/offerHelpers/components/OfferUpdatePageContainer';
import { OfferType } from '@occc-app/offerValidationService/types';
import { useChainId } from '@occc-app/Chain/hooks';
import { getUpdatePageLinks, useGetCampaignName } from '@occc-app/routes/CampaignComponents/utils';

import { messages } from '../messages';
import { OfferConfigureFormContainer } from '../components/OfferConfigureForm/OfferConfigureFormContainer';

export const OfferUpdatePageContainer: React.FC = () => {
  const { id: campaignId = '', offerId = '' } = useParams<{ id: string; offerId: string }>();
  const chainId = useChainId();
  const campaignName = useGetCampaignName(chainId, campaignId);
  const getBreadcrumbLinks = (campaignComponentName: string) =>
    getUpdatePageLinks({
      campaignId,
      campaignComponentId: offerId,
      campaignName,
      pageTitle: messages.configurePageTitle,
      campaignComponentName,
    });

  return (
    <CampaignComponentUpdatePageContainer
      campaignId={campaignId}
      offerId={offerId}
      getBreadcrumbLinks={getBreadcrumbLinks}
      pageTitle={messages.configurePageTitle}
      subtitle={messages.subtitle}
      offerType={OfferType.Offer}
      ConfigureFormContainer={OfferConfigureFormContainer}
    />
  );
};
